import React from 'react';
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom';
import AutoPayFlow from '@/flows/AutoPayFlow';
import InvoiceFlow from '@/flows/InvoiceFlow';
import CheckoutResultFlow from '@/flows/CheckoutResultFlow';
import CardShell from '@/components/CardShell';
import DeadLinkScreen from '@/screens/DeadLinkScreen';

const App = () => (
	<BrowserRouter>
		<Routes>
			<Route path="/auto-pay" element={<AutoPayFlow />} />
			<Route path="/invoice" element={<InvoiceFlow />} />
			<Route path="/pay/success" element={<CheckoutResultFlow outcome="success" />} />
			<Route path="/pay/cancel" element={<CheckoutResultFlow outcome="cancel" />} />
			<Route path="/" element={<Navigate to="/auto-pay" replace />} />
			<Route
				path="*"
				element={
					<CardShell>
						<DeadLinkScreen variant="link_not_found" />
					</CardShell>
				}
			/>
		</Routes>
	</BrowserRouter>
);

export default App;
